module.exports = __webpack_public_path__ + "img/gloria.3aa66260.png";